export class FormConstants {
    static FORM_CLOSED_RESULT = "formClosed";
    static FORM_CANCELED_RESULT = "formCanceled";
}
